import React, { useState } from 'react';

/**
 * BrandLogo — hochauflösende, farbige Markenlogos.
 * Kette: lokales SVG → Simple Icons CDN (SVG) → Text-Fallback.
 * Keine Favicon-Quellen mehr (icon.horse etc.) — die lieferten unscharfe Raster-Icons.
 */
export default function BrandLogo({ name, localSvg, slug, size = 40, maxWidth, dark = false, className = '' }) {
  const sources = [];
  if (localSvg) sources.push(`/img/brands/${localSvg}.svg`);
  if (slug) sources.push(`https://cdn.simpleicons.org/${slug}`);

  const [idx, setIdx] = useState(0);

  if (idx >= sources.length) {
    return (
      <span
        className={`font-display text-lg font-semibold tracking-tight ${dark ? 'text-stone-200' : 'text-stone-600'} ${className}`}
        data-testid={`brand-fallback-${name}`}
      >
        {name}
      </span>
    );
  }

  return (
    <img
      src={sources[idx]}
      alt={name}
      onError={() => setIdx((i) => i + 1)}
      loading="lazy"
      style={{ height: size, maxHeight: size, maxWidth: maxWidth || '100%' }}
      className={`object-contain w-auto ${className}`}
      data-testid={`brand-logo-${name}`}
    />
  );
}
